import { useAuth } from "@/hooks/useAuth";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { FC, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

export const Login: FC = () => {
    const [remember, setRemember] = useLocalStorage("remember-token", false);
    const [remembered, setRemembered] = useLocalStorage("remembered-token", "");
    const [token, setToken] = useState(remember ? remembered : "");
    const { setToken: login } = useAuth();
    const navigate = useNavigate();

    const handleLogin = useCallback(() => {
        if (remember) {
            setRemembered(token);
        }
        login(token)
        navigate("/home");
    }, [remember, token, login, navigate, setRemembered]);

    return (
        <div className="min-h-screen min-w-xl flex items-center justify-center">
            <form className="flex flex-col items-stretch w-lg mx-auto">
                <div className="mb-5">
                    <label htmlFor="token" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Token</label>
                    <input type="password" id="token" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required value={token ?? ""} onChange={(e) => setToken(e.target.value)} />
                </div>
                <div className="flex items-start mb-5">
                    <div className="flex items-center h-5">
                        <input id="remember" type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} value="remember" className="w-4 h-4 border border-gray-300 rounded-sm bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800" required />
                    </div>
                    <label htmlFor="remember" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Speichern</label>
                </div>
                <button type="button" className="self-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" onClick={handleLogin}>Login</button>
            </form>
        </div>
    );
}